import React, { useEffect, useRef, useState } from 'react'
import { HEADER_LEFT } from './Grid.js'
import { CELL_SIZE } from './Cell.js'
import { COLS } from '@fleetduel/shared'

// The 2D grid renders at a fixed pixel size; scale it down to fill its
// wrapper so boards always fit their container (and the screen) on mobile.
const GRID_NATURAL_WIDTH = HEADER_LEFT + COLS.length * CELL_SIZE

export function ScaledGrid({ children }: { children: React.ReactNode }) {
  const outerRef = useRef<HTMLDivElement>(null)
  const innerRef = useRef<HTMLDivElement>(null)
  const [scale, setScale] = useState(1)
  const [height, setHeight] = useState<number | undefined>(undefined)

  useEffect(() => {
    const outer = outerRef.current
    const inner = innerRef.current
    if (!outer || !inner) return
    const update = () => {
      const s = Math.min(1, outer.clientWidth / GRID_NATURAL_WIDTH)
      setScale(s)
      setHeight(inner.offsetHeight * s)
    }
    update()
    const ro = new ResizeObserver(update)
    ro.observe(outer)
    return () => ro.disconnect()
  }, [])

  return (
    <div ref={outerRef} style={{ width: '100%', height, display: 'flex', justifyContent: 'center', overflow: 'hidden' }}>
      {/* alignSelf keeps the inner at its natural content height — without it
          the default flex stretch ties it to the outer height we set above,
          and each ResizeObserver pass would shrink it toward zero */}
      <div ref={innerRef} style={{ flex: 'none', alignSelf: 'flex-start', transform: `scale(${scale})`, transformOrigin: 'top center' }}>
        {children}
      </div>
    </div>
  )
}
